import { useTranslation } from 'react-i18next';
import { TikTokReviewInfluencersButton } from '@anytag/shared-organisms';
import { PricingTableItem, TikTokProductCategory } from '@anytag/graphql';
import { useSelectItem, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { cn } from '@anytag/shared-utils';
import { Form } from '@anytag/shared-atoms';
import { CampaignPlansList } from './CampaignPlansList';
import { ProductCategoriesList } from './ProductCategoriesList';

interface SelectCampaignPlanProps {
  marketplacePlans: readonly PricingTableItem[];
}

export const SelectCampaignPlan = ({ marketplacePlans }: SelectCampaignPlanProps) => {
  useUpdateDocumentTitle({
    alwaysBackToParent: true,
    href: '/tiktok/campaigns',
    title: 'documentTitle.TikTok Influencer Campaigns Select Plan',
    appHeader: 'appHeader.TikTok Influencer Campaigns Select Plan'
  });
  const { t } = useTranslation();
  const selectItemProps = useSelectItem<TikTokProductCategory>();

  const { selectedItem } = selectItemProps;

  return (
    <>
      <div className={styles.sectionWrapper}>
        <Form.SectionTitle index={1} className={styles.sectionTitle} label={t('Choose your product category')} />
        <ProductCategoriesList {...selectItemProps} />
      </div>

      <div className={cn(styles.sectionWrapper, 'mt-4')}>
        <Form.SectionTitle index={2} label={t('Select a campaign plan')} className={cn(styles.sectionTitle, 'mb-0')}>
          <TikTokReviewInfluencersButton
            disabled={!selectedItem?.packageId}
            to="/tiktok/campaigns/review-influencers"
            search={{ filter: { packageId: selectedItem?.packageId } }}
            className="ml-auto w-full max-w-[312px]"
          />
        </Form.SectionTitle>

        <CampaignPlansList marketplacePlans={marketplacePlans} selectedItem={selectedItem} />
      </div>
    </>
  );
};

const styles = {
  sectionWrapper: cn('box-border rounded-sm bg-white p-6 shadow-container'),
  sectionTitle: cn('mb-6 font-semibold')
};
